import { render, staticRenderFns } from "./ProviderCategory.vue?vue&type=template&id=f997fb68&scoped=true&"
import script from "./ProviderCategory.vue?vue&type=script&lang=js&"
export * from "./ProviderCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCategory.vue?vue&type=style&index=0&id=f997fb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f997fb68",
  null
  
)

export default component.exports